module["exports"] = [
  "1###",
  "2###",
  "3###",
  "4###",
  "5###",
  "6###",
  "7###",
  "8###",
  "9###"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/de_CH/address/postcode.js
// module id = 2524
// module chunks = 1610